import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import * as R from 'ramda';

import {Tabs as DXTabs} from 'devextreme-react';


export default class Tabs extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedIndex: this.props.selectedIndex,
            // selectedItem: this.props.selectedItem,
            // selectedItemKeys: this.props.selectedItemKeys || [],
        };

        this.itemTemplate = this.itemTemplate.bind(this);
        this.onOptionChanged = this.onOptionChanged.bind(this);
        this.onItemClick = this.onItemClick.bind(this);
    }

    UNSAFE_componentWillReceiveProps(props) {
        if (this.state.selectedIndex !== props.selectedIndex) {
            this.setState({
                selectedIndex: props.selectedIndex,
            });
        }
    }

    itemTemplate(template_id) {
        var tmpl = window[template_id];
        return function(itemData, itemIndex, element) {
            ReactDOM.render(tmpl(itemData), element);
        }
    }

    onOptionChanged(e) {
        // console.log('onOptionChanged', e)

        // if (e.name === 'selectedItem') {
        //     // console.log(e.value)
        //     // this.setState({selectedItem: e.value});
        //     this.setState({selectedItemKeys: [e.value.id]});
        // }

        if(e.name === 'selectedIndex') {
            this.setState({
                selectedIndex: e.value,
                // selectedItem: this.props.dataSource[this.props.dataSource.indexOf(e.value)],
            });
            const {setProps} = this.props;

            if (setProps) {
                setProps({
                    selectedIndex: e.value
                });
            }
        }

        // if(e.name === 'selectedItem') {
        //     // console.log('onOptionChanged', e)
        //     // this.setState({
        //     //     selectedItem: e.selectedItem
        //     // });
        //     this.setState({
        //         selectedIndex: e.value,
        //         selectedItem: this.props.dataSource[this.props.dataSource.indexOf(e.value)],
        //     });
        // }
    }

    onItemClick(e) {
        // console.log('Tabs onItemClick', e)
        // this.setState({
        //     selectedIndex: e.itemIndex
        // })
        const {setProps} = this.props;

        if (setProps) {
            setProps({
                itemClick: {
                    data: e.itemData,
                    itemIndex: e.itemIndex
                }
            });
        }
    }

    // componentDidCatch(error, errorInfo) {
    //     console.log('ERROR', error, errorInfo)
    // }

    render() {
        const dataAttributes = {};
        if (this.props.loading_state && this.props.loading_state.is_loading) {
            dataAttributes['data-dash-is-loading'] = true;
        }

        let {itemTemplate} = this.props;

        if (itemTemplate && typeof itemTemplate === 'string' && itemTemplate !== 'item'){
            itemTemplate = this.itemTemplate(itemTemplate);
        }

        /*
                {...R.omit(['loading_state', 'setProps'], this.props)}
                {...dataAttributes}
                itemTemplate={itemTemplate}
                selectedIndex={this.state.selectedIndex}
                onOptionChanged ={this.props.onOptionChanged || this.onOptionChanged}
                onItemClick ={this.props.onItemClick || this.onItemClick}
        * */
        return (
            <DXTabs
                {...R.omit(['loading_state', 'setProps'], this.props)}
                {...dataAttributes}
                itemTemplate={itemTemplate}
                // selectedItem={this.state.selectedItem}
                selectedIndex={this.state.selectedIndex}
                onOptionChanged ={this.props.onOptionChanged || this.onOptionChanged}
                // onSelectionChanged ={this.props.onSelectionChanged || this.onSelectionChanged}
                onItemClick ={this.props.onItemClick || this.onItemClick}
            />
        )
    }
}

Tabs.propTypes = {
    /**
     * The ID used to identify this component in Dash callbacks
     */
    id: PropTypes.string,

    /**
     * Specifies the shortcut key that sets focus on the UI component
     */
    accessKey: PropTypes.string,
    /**
     * Binds the UI component to data
     */
    dataSource: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.object), PropTypes.object]),
    /**
     * Specifies whether the UI component responds to user interaction
     */
    disabled: PropTypes.bool,
    /**
     * Specifies the global attributes to be attached to the UI component's container element
     */
    elementAttr: PropTypes.object,
    /**
     * Specifies whether the UI component can be focused using keyboard navigation
     */
    focusStateEnabled: PropTypes.bool,
    /**
     * Specifies the UI component's height
     */
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),
    /**
     * Specifies text for a hint that appears when a user pauses on the UI component
     */
    hint: PropTypes.string,
    /**
     * Specifies whether the UI component changes its state when a user pauses on it
     */
    hoverStateEnabled: PropTypes.bool,
    /**
     * Dash event
     */
    itemClick: PropTypes.object,
    /**
     * An alias for the itemTemplate property specified in React. Accepts a custom component.
     */
    itemComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    /**
     * The time period in milliseconds before the onItemHold event is raised
     */
    itemHoldTimeout: PropTypes.number,
    /**
     * An alias for the itemTemplate property specified in React. Accepts a rendering function.
     */
    itemRender: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    /**
     * An array of items displayed by the UI component
     */
    items: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.object)]),
    /**
     * Specifies a custom template for items
     */
    itemTemplate: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
    /**
     * Specifies the key property that provides key values to access data items. Each key value must be unique.
     */
    keyExpr: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    /**
     * The text or HTML markup displayed by the UI component if the item collection is empty
     */
    noDataText: PropTypes.string,
    /**
     * A function that is executed when the UI component's content is ready and each time the content is changed
     */
    onContentReady: PropTypes.func,
    /**
     * A function that is executed before the UI component is disposed of
     */
    onDisposing: PropTypes.func,
    /**
     * A function used in JavaScript frameworks to save the UI component instance
     */
    onInitialized: PropTypes.func,
    /**
     * A function that is executed when a collection item is clicked or tapped
     */
    onItemClick: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    /**
     * A function that is executed when a collection item is right-clicked or pressed
     */
    onItemContextMenu: PropTypes.func,
    /**
     * A function that is executed when a collection item has been held for a specified period
     */
    onItemHold: PropTypes.func,
    /**
     * A function that is executed after a collection item is rendered
     */
    onItemRendered: PropTypes.func,
    /**
     * A function that is executed after a UI component property is changed
     */
    onOptionChanged: PropTypes.func,
    /**
     * A function that is executed when a collection item is selected or selection is canceled
     */
    onSelectionChanged: PropTypes.func,
    /**
     * Specifies whether to repaint only those elements whose data changed
     */
    repaintChangesOnly: PropTypes.bool,
    /**
     * Switches the UI component to a right-to-left representation
     */
    rtlEnabled: PropTypes.bool,
    /**
     * Specifies whether or not an end-user can scroll tabs by swiping
     */
    scrollByContent: PropTypes.bool,
    /**
     * Specifies whether or not an end-user can scroll tabs
     */
    scrollingEnabled: PropTypes.bool,
    /**
     * The index of the currently selected UI component item
     */
    selectedIndex: PropTypes.number,
    /**
     * The selected item object
     */
    selectedItem: PropTypes.object,
    /**
     * Specifies an array of currently selected item keys
     */
    selectedItemKeys: PropTypes.number,
    /**
     * An array of currently selected item objects
     */
    selectedItems: PropTypes.arrayOf(PropTypes.any),
    /**
     * Specifies whether the UI component enables an end-user to select only a single item or multiple items
     */
    selectionMode: PropTypes.oneOf(['multiple', 'single']),
    /**
     * Specifies whether navigation buttons should be available when tabs exceed the UI component's width
     */
    showNavButtons: PropTypes.bool,
    /**
     * Specifies the number of the element when the Tab key is used for navigating
     */
    tabIndex: PropTypes.number,
    /**
     * Specifies whether the UI component is visible
     */
    visible: PropTypes.bool,
    /**
     * Specifies the UI component's width
     */
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),

    /**
     * Dash-assigned callback that gets fired when the value changes.
     */
    setProps: PropTypes.func,
    /**
     * Object that holds the loading state object coming from dash-renderer
     */
    loading_state: PropTypes.shape({
        /**
         * Determines if the component is loading or not
         */
        is_loading: PropTypes.bool,
        /**
         * Holds which property is loading
         */
        prop_name: PropTypes.string,
        /**
         * Holds the name of the component that is loading
         */
        component_name: PropTypes.string,
    }),
};

Tabs.defaultProps = {
    accessKey: null,
    dataSource: null,
    disabled: false,
    elementAttr: {},
    focusStateEnabled: true,
    height: 'auto',
    // hint: undefined,
    hoverStateEnabled: true,
    itemComponent: null,
    itemHoldTimeout: 750,
    itemRender: null,
    items: null,
    itemTemplate: 'item',
    keyExpr: null,
    noDataText: 'No data to display',
    onContentReady: null,
    onDisposing: null,
    onInitialized: null,
    onItemClick: null,
    onItemContextMenu: null,
    onItemHold: null,
    onItemRendered: null,
    onOptionChanged: null,
    onSelectionChanged: null,
    repaintChangesOnly: false,
    rtlEnabled: false,
    scrollByContent: false,
    scrollingEnabled: true,
    selectedIndex: 0,
    // selectedItem: null,
    // selectedItemKeys: null,
    // selectedItems: null,
    selectionMode: 'single',
    showNavButtons: true,
    tabIndex: 0,
    visible: true,
    width: 'auto'
};
